import { LinkItemSchema } from '@/views/sports/components/CompetitionsMenu/styles/LinkItem.styles';

export const linkItemStyles: LinkItemSchema = {
  link: {
    bg: 'gamma.500',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    py: '2',
    pl: '3',
    pr: '2',
    mb: '1px',
    color: 'white',
    _hover: {
      textDecoration: 'none',
    },
    _last: {
      mb: 0,
    },
  },
  textCompetitionName: {
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxW: '140px',
  },
  textMatchCount: {
    px: '1',
    fontSize: '2xs',
    fontWeight: 'bold',
  },
};
